import {
  GET_BANNERS_START,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_ERROR,
  ADD_BANNER_START,
  ADD_BANNER_SUCCESS,
  ADD_BANNER_ERROR,
  UPDATE_BANNER_START,
  UPDATE_BANNER_SUCCESS,
  UPDATE_BANNER_ERROR,
  DELETE_BANNER_START,
  DELETE_BANNER_SUCCESS,
  DELETE_BANNER_ERROR,
  GET_BANNER_PLACEMENTS_START,
  GET_BANNER_PLACEMENTS_SUCCESS,
  GET_BANNER_PLACEMENTS_ERROR
} from '../constants';

const initialState = {
  items: [],
  count: 0,
  loading: false,
  error: null,
  placements: []
};

export default function adminBanners(state = initialState, action) {
  switch (action.type) {
    case GET_BANNERS_START:
    case ADD_BANNER_START:
    case UPDATE_BANNER_START:
    case DELETE_BANNER_START:
    case GET_BANNER_PLACEMENTS_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_BANNERS_SUCCESS:
      return {
        ...state,
        items: Array.isArray(action.payload.items) ? [...action.payload.items] : [],
        count: typeof action.payload.count === 'number' ? action.payload.count : 0,
        loading: false,
        error: null
      };
    case GET_BANNER_PLACEMENTS_SUCCESS:
      return {
        ...state,
        placements: Array.isArray(action.payload) ? [...action.payload] : [],
        loading: false,
        error: null
      };
    case ADD_BANNER_SUCCESS:
    case UPDATE_BANNER_SUCCESS:
    case DELETE_BANNER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case GET_BANNERS_ERROR:
    case ADD_BANNER_ERROR:
    case UPDATE_BANNER_ERROR:
    case DELETE_BANNER_ERROR:
    case GET_BANNER_PLACEMENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error || 'Error occurred'
      };
    default:
      return state;
  }
} 